import React from 'react';

import { BulletinData } from 'pages/Bulletin/types/bulletin-data';

import useStyles from './styles';

import Metrics from '../Metrics';
import RevisionSelect from '../RevisionSelect';
import Tags from '../Tags';
import Toolbar from '../Toolbar';

interface Props {
    data: BulletinData;
    className?: string;
}

const AsideSection: React.FC<Props> = ({ data, className }) => {
    const { classes, cx } = useStyles();
    return (
        <div className={cx(classes.root, className)}>
            <RevisionSelect id={data.id} published={data.published} />
            <Metrics metrics={data.metrics} epss={data.epss} aiScore={data.aiScore} />
            <Tags data={data.raw.data} compact className={classes.tags} />
            <Toolbar id={data.id} viewsCount={data.viewCount} className={classes.toolbar} />
        </div>
    );
};

export default AsideSection;
